import { render, staticRenderFns } from "./QuestionTagsSelector.vue?vue&type=template&id=5ca44d19&"
import script from "./QuestionTagsSelector.vue?vue&type=script&lang=js&"
export * from "./QuestionTagsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports